import { Injectable } from '@angular/core';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbPasswordAuthStrategy, NbAuthJWTToken } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { environment } from './../../environments/environment';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { AnalyticsService } from './utils';
import { UserData } from './data/users';
import { UserService } from './mock/users.service';
import { MockDataModule } from './mock/mock-data.module';
import { DataModule } from './data/data.module';
import { WaffleCurrentUserService } from './data/waffle-currentuser.service';
import { Observable } from 'rxjs/Observable';
import { from } from 'rxjs';

const DATA_SERVICES = [
  { provide: UserData, useClass: UserService },
];

@Injectable()
export class NbSimpleRoleProvider implements NbRoleProvider {

  constructor(private wafflecurrentuserservice: WaffleCurrentUserService) {
  }

  getRole(): Observable<string> {
    return from(this.wafflecurrentuserservice.Initloading());
  }

}

export const NB_CORE_PROVIDERS = [
  ...DataModule.forRoot().providers,
  ...MockDataModule.forRoot().providers,
  ...DATA_SERVICES,
  ...NbAuthModule.forRoot({

    strategies: [
      NbPasswordAuthStrategy.setup({
        name: 'email',
        token: {
          class: NbAuthJWTToken,
        },
        baseEndpoint: environment.ApiEndPoint,
        login: {
          endpoint: '/crm/v2/users/phone/login',
        },
        logout: {
          method: null,
          endpoint: '',
          redirect: {
            success: '/crm/v2/users/phone/login',
            failure: '/crm/v2/users/phone/login',
          },
        },
      }),
    ],
    forms: {
      validation: {
        password: {
          required: true,
          minLength: 4,
          maxLength: 50,
        },
        phone: {
          required: true,
        },
      },
    },
  }).providers,

  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: '*',
      },
      user: {
        parent: 'guest',
        create: '*',
        edit: '*',
        remove: '*',
      },
    },
  }).providers,

  {
    provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
  },
  AnalyticsService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}
